<template>
  <div>


    <div v-if="data">
      <div style="display: flex; justify-content: center; margin-bottom: 24px; margin-top: 24px;">
        <div style="display: flex; align-self: center">
          <mu-float-button
            style="margin: 2px;"
            mini
            label="M"
            v-for="(day, dayIndex) in data.days"
            :key="'day-' + dayIndex"
            :class="{'activeDay': day.name === activeDay}"
            v-if="data.availableDays.includes(day.name)"

            class="day-button"
            @click.native="setDay(day.name)">
            {{day.label}}
          </mu-float-button>
        </div>
      </div>


      <div class="content">
        <mu-content-block>
          <h1 v-if="data">{{data.name}}</h1>
          <p style="margin-top: 0; margin-bottom: 24px">{{data.availableDays.length}} day meal plan</p>
          <div style="margin-bottom: 24px">
            <mu-raised-button v-if="readonly" icon="delete" label="Delete"
                              @click.native="deleteMealPlan"></mu-raised-button>

            <mu-raised-button :icon="readonly ? 'save_alt' : 'cancel'" :label="readonly ? 'Create from' : 'Cancel'"
                              v-tooltip.top="'Create a new meal plan based of this one.'"
                              @click.native="toggleReadonly"></mu-raised-button>


            <mu-raised-button primary v-if="!readonly" icon="check" :label="$t('message.saveText')"
                              v-tooltip.top="'Save as new meal'"
                              @click.native="openModal"></mu-raised-button>

          </div>
        </mu-content-block>
      </div>


      <meal-plan-panel
        v-if="data.availableMeals.includes('BREAKFAST')"
        :readonly="readonly"
        :activeDay="activeDay"
        type="breakfast"
        :recipe="activeBreakfastForDay"
        @changed="pushToBreakfast"
      >
      </meal-plan-panel>

      <meal-plan-panel
        v-if="data.availableMeals.includes('LUNCH')"
        :readonly="readonly"
        :activeDay="activeDay"
        type="lunch"
        :recipe="activeLunchForDay"
        @changed="pushToLunch"
      >
      </meal-plan-panel>

      <meal-plan-panel
        v-if="data.availableMeals.includes('DINNER')"
        :readonly="readonly"
        :activeDay="activeDay"
        type="dinner"
        :recipe="activeDinnerForDay"
        @changed="pushToDinner"
      >
      </meal-plan-panel>
    </div>


    <mu-dialog :open="dialogOpen" title="Give your meal plan a name" @close="dialogOpen = false">
      <form @submit.prevent="saveMealPlan">
        <mu-text-field
          v-model="custom.name"
          full-width
          label="Name"
          hint-text="Enter a name for your meal plan">
        </mu-text-field>
        <div align="right">
          <mu-flat-button slot="actions" @click="dialogOpen = false" primary :label="$t('message.cancelText')"/>
          <button type="submit" style="display: none"></button>
          <mu-raised-button
            type="button"
            @click.native="saveMealPlan"
            slot="actions"
            primary
            @click="dialogOpen = false"
            :label="$t('message.okText')"
          />
        </div>
      </form>
    </mu-dialog>

  </div>
</template>

<script>
  import RecipeApi from '../../api/Recipes'
  import MealPlanPanel from "./MealPlanGenerator/components/meal-plan-panel";

  export default {
    components: {MealPlanPanel},
    name: "meal-plan-detail",
    data() {
      return {
        dialogOpen: false,
        readonly: true,
        activeDay: null,
        data: false,
        target: false,
        custom: {
          name: null
        }
      }
    },
    watch: {
      '$route': function () {
        let self = this;
        RecipeApi.getMealPlanById(self.$route.params.id)
          .then(function (response) {
            self.activeDay = response.data.availableDays[0];
            self.data = response.data;
          })
          .catch(function (error) {
            //doesn't exist route back to my meal plans
            self.$router.push({
              name: 'RecipeMealPlans'
            })
          })
      }
    },
    methods: {
      saveMealPlan() {
        let self = this;

        let model = self.data;
        model.name = self.custom.name;

        RecipeApi.addMealPlan(model)
          .then(function (response) {
            self.custom.name = "";
            self.dialogOpen = false;
            self.readonly = true;
            self.$router.push({
              name: 'MealPlanDetail',
              params: {
                id: response.data.id
              }
            })
          })
      },
      openModal() {
        this.dialogOpen = true;
      },
      toggleReadonly() {
        let self = this;
        self.readonly = !self.readonly;

        if (self.readonly === true) {
          RecipeApi.getMealPlanById(self.$route.params.id)
            .then(function (response) {
              self.activeDay = response.data.availableDays[0];
              self.data = response.data;
            })
            .catch(function (error) {
              //doesn't exist route back to my meal plans
              self.$router.push({
                name: 'RecipeMealPlans'
              })
            })
        }

      },
      deleteMealPlan() {
        let self = this;
        let swal = self.$alert;
        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          text: "You about about to remove a meal plan!",
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return RecipeApi.deleteMealPlan(self.data.id)
          }
        })
          .then(function (response) {
            self.$alert({
              title: self.$t('message.labelSuccess'),
              text: "Meal plan was removed",
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            });
            self.$router.push({
              name: 'RecipeMealPlans'
            })

          }.bind(self))
          .catch(self.$alert.noop)
      },
      setDay(day) {
        this.activeDay = day;
      },
      pushToBreakfast(recipe) {
        let self = this;
        let currentDay = self.data.days.filter(function (item) {
          return item.name === self.activeDay;
        });
        let day = currentDay[0];
        day.breakfast = [];
        day.breakfast.push(recipe);
      },
      pushToLunch(recipe) {
        let self = this;
        let currentDay = self.data.days.filter(function (item) {
          return item.name === self.activeDay;
        });
        let day = currentDay[0];
        day.lunch = [];
        day.lunch.push(recipe);
      },
      pushToDinner(recipe) {
        let self = this;
        let currentDay = self.data.days.filter(function (item) {
          return item.name === self.activeDay;
        });
        let day = currentDay[0];
        day.dinner = [];
        day.dinner.push(recipe);
      },
    },
    computed: {
      activeBreakfastForDay() {
        let self = this;
        if (self.data === false) {
          return [];
        }

        let item = self.data.days.filter(function (item) {
          return item.name === self.activeDay;
        });
        if (item[0].breakfast.length > 0) {
          return item[0].breakfast;
        }
        return [];
      },
      activeDinnerForDay() {
        let self = this;
        if (self.data === false) {
          return [];
        }

        let item = self.data.days.filter(function (item) {
          return item.name === self.activeDay;
        });
        if (item[0].dinner.length > 0) {
          return item[0].dinner;
        }
        return [];
      },
      activeLunchForDay() {
        let self = this;
        if (self.data === false) {
          return [];
        }

        let item = self.data.days.filter(function (item) {
          return item.name === self.activeDay;
        });
        if (item[0].lunch.length > 0) {
          return item[0].lunch;
        }
        return [];
      }
    },
    mounted() {
      let self = this;

      RecipeApi.getMealPlanById(self.$route.params.id)
        .then(function (response) {
          self.activeDay = response.data.availableDays[0];
          self.data = response.data;
        })
        .catch(function (error) {
          //doesn't exist route back to my meal plans
          self.$router.push({
            name: 'RecipeMealPlans'
          })
        })
    }
  }
</script>




// WEBPACK FOOTER //
// MealPlanDetail.vue?706b4012